// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__modulesContainer--HSzwG {
  overflow: auto;
  padding-top: 0.5rem;
}
.style__moduleTable--Z3WeN {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--sys-color-outline-variant);
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.875rem;
  table-layout: fixed;
}
.style__moduleTable--Z3WeN th, .style__moduleTable--Z3WeN td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--sys-color-outline-variant);
}
.style__moduleTable--Z3WeN th {
  font-weight: 600;
  color: var(--sys-color-on-surface-variant);
  border-bottom: 2px solid var(--sys-color-outline-variant);
}
.style__moduleTable--Z3WeN td {
  vertical-align: middle;
}
.style__moduleTable--Z3WeN tr:last-child td {
  border-bottom: none;
}
.style__moduleTable--Z3WeN tr:not(.style__groupRow--nLU3l):hover td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__moduleRow--Wz64O {
  cursor: pointer;
}
.style__groupRow--nLU3l td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__groupCell--IAx6i {
  padding: 0.75rem 1rem;
}
.style__thIndex--ami88, .style__tdIndex--u6npZ {
  width: 3rem;
  text-align: center;
}
.style__thName--B7P3L, .style__tdName--Kxqjk {
  width: auto;
}
.style__thGear--VnI7I, .style__tdGear--W4EXZ {
  width: 10rem;
}
.style__thVersions--qru_g, .style__tdVersions--MNHwq {
  width: 14rem;
  white-space: normal;
  word-break: break-word;
}
.style__emptyState--SQcwo {
  padding: 2rem 0;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CustomModulesPage/style.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;EACA,mBAAA;AAFJ;AADA;EAOI,WAAA;EACA,yBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAHJ;AAVA;EAgBM,qBAAA;EACA,gBAAA;EACA,yDAAA;AAFN;AAhBA;EAsBM,gBAAA;EACA,0CAAA;EACA,yDAAA;AAHN;AArBA;EA4BM,sBAAA;AAJN;AAxBA;EAgCM,mBAAA;AALN;AA3BA;EAoCM,iEAAA;AANN;AA9BA;EAyCI,eAAA;AARJ;AAjCA;EA8CM,iEAAA;AAVN;AApCA;EAmDI,qBAAA;AAZJ;AAvCA;EAuDI,WAAA;EACA,kBAAA;AAZJ;AA5CA;EA4DI,WAAA;AAZJ;AAhDA;EAgEI,YAAA;AAZJ;AApDA;EAoEI,YAAA;EACA,mBAAA;EACA,sBAAA;AAZJ;AA1DA;EA0EI,eAAA;EACA,kBAAA;AAbJ","sourcesContent":["@import '@yaak/components/src/spacing';\n\n:local {\n  .modulesContainer {\n    overflow: auto;\n    padding-top: @spacing-50;\n  }\n\n  .moduleTable {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid var(--sys-color-outline-variant);\n    border-radius: 8px;\n    overflow: hidden;\n    font-size: 0.875rem;\n    table-layout: fixed;\n\n    th, td {\n      padding: @spacing-75 @spacing-100;\n      text-align: left;\n      border-bottom: 1px solid var(--sys-color-outline-variant);\n    }\n\n    th {\n      font-weight: 600;\n      color: var(--sys-color-on-surface-variant);\n      border-bottom: 2px solid var(--sys-color-outline-variant);\n    }\n\n    td {\n      vertical-align: middle;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:not(.groupRow):hover td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .moduleRow {\n    cursor: pointer;\n  }\n\n  .groupRow {\n    td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .groupCell {\n    padding: @spacing-75 @spacing-100;\n  }\n\n  .thIndex, .tdIndex {\n    width: 3rem;\n    text-align: center;\n  }\n\n  .thName, .tdName {\n    width: auto;\n  }\n\n  .thGear, .tdGear {\n    width: 10rem;\n  }\n\n  .thVersions, .tdVersions {\n    width: 14rem;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .emptyState {\n    padding: @spacing-200 0;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modulesContainer": `style__modulesContainer--HSzwG`,
	"moduleTable": `style__moduleTable--Z3WeN`,
	"groupRow": `style__groupRow--nLU3l`,
	"moduleRow": `style__moduleRow--Wz64O`,
	"groupCell": `style__groupCell--IAx6i`,
	"thIndex": `style__thIndex--ami88`,
	"tdIndex": `style__tdIndex--u6npZ`,
	"thName": `style__thName--B7P3L`,
	"tdName": `style__tdName--Kxqjk`,
	"thGear": `style__thGear--VnI7I`,
	"tdGear": `style__tdGear--W4EXZ`,
	"thVersions": `style__thVersions--qru_g`,
	"tdVersions": `style__tdVersions--MNHwq`,
	"emptyState": `style__emptyState--SQcwo`
};
export default ___CSS_LOADER_EXPORT___;
